import { RequestClientService } from "@rightship-tech/common-ui/services/basic/request-client.service";
import { autoinject } from "aurelia-framework";
import { CrewWelfareRoutes } from "../../constants/vetting/crew-welfare.constants";
import { CheckCWStatusByDOCCompanyOrVesselResponse, SubmitCWSAClientSearchToolRequest } from "../../models/crew-welfare/cwsa-search-tool.models";

@autoinject
export class CrewWelfareSearchToolService {
    constructor(private requestClient: RequestClientService) {
    }

    submitCWSAClientSearchTool(request: SubmitCWSAClientSearchToolRequest): Promise<any> {
        return this.requestClient.post(CrewWelfareRoutes.SubmitCWSAClientSearchTool, {}, request);
    }

    checkExpiryDateCWSAClientSearchTook(request: { token: string }): Promise<any> {
        return this.requestClient.get(CrewWelfareRoutes.VerifyExpiryDateAccessCWSASearchTool, request);
    }

    checkCWStatusByDOCCompanyOrVessel(encryptedId: string, entityType: string): Promise<CheckCWStatusByDOCCompanyOrVesselResponse> {
        return this.requestClient.get(CrewWelfareRoutes.CheckCWStatusByDOCCompanyOrVessel, { eId: encryptedId, entityType: entityType });
    }
}
